import React from 'react'
import { Logo } from '../../assests/ExportImageIcon'
import './CarSearchLoader.css'

const CarIcon = () => (
    <svg viewBox="0 0 80 46" className='carSearchLoader__carSvg'>
        <defs>
            <linearGradient id="carSearchLoaderCarGrad" x1="0" y1="0" x2="80" y2="46" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#3fc98e" />
                <stop offset="1" stopColor="#0f6b4f" />
            </linearGradient>
        </defs>
        <path d="M8 28 L13 15 Q16 9 24 9 H52 Q60 9 63 15 L68 28 Z" fill="url(#carSearchLoaderCarGrad)" />
        <rect x="3" y="25" width="74" height="13" rx="6" fill="url(#carSearchLoaderCarGrad)" />
        <path d="M20 15 Q22 12 26 12 H48 Q52 12 55 16 L57 22 H18 Z" fill="#eafaf1" />
        <g className='carSearchLoader__wheel carSearchLoader__wheel--front'>
            <circle cx="20" cy="38" r="7" fill="#232427" />
            <circle cx="20" cy="38" r="3" fill="#d9d9d9" />
        </g>
        <g className='carSearchLoader__wheel carSearchLoader__wheel--rear'>
            <circle cx="60" cy="38" r="7" fill="#232427" />
            <circle cx="60" cy="38" r="3" fill="#d9d9d9" />
        </g>
    </svg>
)

const CarSearchLoader = ({ text = 'Finding the best cars for you', size = 'default' }) => {
    return (
        <div className={`carSearchLoader ${size === 'compact' ? 'carSearchLoader--compact' : ''}`}>
            <div className='carSearchLoader__logoCircle'>
                <img src={Logo} alt='' />
            </div>

            <div className='carSearchLoader__roadWrap'>
                <div className='carSearchLoader__lane' />
                <div className='carSearchLoader__car'>
                    <CarIcon />
                </div>
            </div>

            {text && (
                <p className='carSearchLoader__text'>
                    {text}
                    <span className='carSearchLoader__dots'>
                        <span>.</span><span>.</span><span>.</span>
                    </span>
                </p>
            )}
        </div>
    )
}

export default CarSearchLoader
